export default "__VITE_ASSET__BNYEljV$__"